import {
  createContext,
  useCallback,
  useContext,
  useState,
} from "react";

const MusicContext = createContext(null);

export function MusicProvider({ children }) {
  const [currentSong, setCurrentSong] = useState(null);

  const playSong = useCallback((song) => {
    setCurrentSong(song);
  }, []);

  return (
    <MusicContext.Provider
      value={{
        currentSong,
        playSong,
      }}
    >
      {children}
    </MusicContext.Provider>
  );
}

export function useMusic() {
  return useContext(MusicContext);
}